"use client";

import { memo } from "react";
import { cn } from "@/lib/utils";
import { IconLoader2, IconReload, IconSearch } from "@tabler/icons-react";

type SearchSubmitButtonProps = {
  className?: string;
  isSubmitting: boolean;
  showReloadIcon: boolean;
  onClick: () => void;
};

const SearchSubmitButton = ({
  className,
  isSubmitting,
  showReloadIcon,
  onClick,
}: SearchSubmitButtonProps) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={isSubmitting}
      aria-busy={isSubmitting}
      aria-label="Search travel options"
      className={cn(
        "flex shrink-0 items-center justify-center bg-primary text-black transition-colors hover:bg-primary-hover md:self-center",
        "h-[46px] w-full md:h-12 md:w-12 md:rounded-full rounded-full",
        isSubmitting && "cursor-not-allowed opacity-70 hover:bg-primary-btn-bg",
        className,
      )}
    >
      {isSubmitting ? (
        <div className="flex items-center justify-center gap-2">
          <IconLoader2
            className="h-6 w-6 shrink-0 animate-spin"
            strokeWidth={2}
          />
          <span className="md:hidden">Loading...</span>
        </div>
      ) : (
        <div className="flex items-center gap-2">
          {showReloadIcon ? (
            <IconReload className="h-6 w-6 shrink-0" strokeWidth={2} />
          ) : (
            <IconSearch className="h-6 w-6 shrink-0" strokeWidth={2} />
          )}
          <span className="md:hidden">Search</span>

        </div>
      )}
    </button>
  );
};

export default memo(SearchSubmitButton);
